import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';


import { FilterItem } from '../../models/filter-item';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatSelectModule, MatSelectionList, MatListModule, MatMenuModule, MatButtonModule, MatInputModule, MatBadgeModule, FormsModule, MatFormFieldModule]
})
export class FilterButtonComponent implements OnInit {
  query = '';
  filteredValues: FilterItem[] | undefined;
  labelText = ''
  private _selectedValues: FilterItem[] = [];

  @Input() label: string = '';
  @Input() showLabel: boolean = false;
  @Input() allValues: string[] = [];
  @Input()
  set selectedValues(value: FilterItem[] | null | undefined) {
    this._selectedValues = Array.isArray(value) ? value : [];
  }
  get selectedValues(): FilterItem[] {
    return this._selectedValues;
  }
  @Input() showLabelAndSelectedValue: boolean = false;
  @Input() selectedValuesIsDefault: boolean = false;
  @Output() selectedValuesChange = new EventEmitter<any[]>();

  @ViewChild('queryInput') queryInput: ElementRef | undefined;


  constructor(public cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.filteredValues = this.allValues.map(f => ({ value: f, activated: true }));
    this.labelText = this.label;
  }

  onSearchMenuOpened() {
    if (!this.queryInput) {
      return;
    }

    this.query = '';
    this.filteredValues = this.allValues.map(f => ({ value: f, activated: true }));

    setTimeout(() => { this.queryInput?.nativeElement.focus() });
  }

  onCheckboxClicked(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    this.selectedValuesChange.emit(this.selectedValues);
  }

  filterSelectableValuesByQuery() {
    if (!this.allValues || !this.selectedValues) {
      return;
    }

    const query = this.query.trim().toLowerCase();
    const values = this.allValues.filter(val => val.toString().trim().toLowerCase().indexOf(query) > -1);
    this.filteredValues = values ? values.map(f => ({ value: f, activated: true })) : this.allValues.map(f => ({ value: f, activated: true }));
  }

  resetSelectedValues() {
    this.selectedValues = [];
    this.selectedValuesChange.emit(this.selectedValues);
  }

  selectAllFilteredValues() {
    this.selectedValues = this.filteredValues?.length ? this.filteredValues : [];
    this.selectedValuesChange.emit(this.selectedValues);
  }

  clearQuery() {
    this.query = "";
  }

  compareByValue = (value: FilterItem, selectedValue: FilterItem): boolean => {
    return this.selectedValues.length > 0 && value?.value === selectedValue?.value;
  };
}
